var _ellipse, _g, _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.784,
    cy: 86,
    rx: 68.784,
    ry: 69,
    fill: "#F9F9F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3888 72.4234V96.8187H44.5458L7.12402 98.0559C13.0424 130.885 41.5269 154.764 74.7837 154.777C104.354 154.749 130.598 135.766 139.964 107.63H130.491V84.0669H117.778V111.788H100.867V92.9376H90.6958V84.3438H81.3001V110.402H66.3775V72.4234H53.3888Z",
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.029 72.701V106.521H115.568V97.0957H111.423V73.8095H99.5398V121.214H94.2892V110.957H81.3004V99.8678H73.9467V74.9569L60.8504 82.5418V106.521H51.5927V126.758H44.2695V92.3831H33.7681V81.8487H6.19637C6.09372 83.1559 6.02824 84.4658 6 85.7767C6.00001 104.077 13.2469 121.627 26.1464 134.567C39.0459 147.507 56.5414 154.777 74.784 154.777C93.0267 154.777 110.522 147.507 123.422 134.567C136.321 121.627 143.568 104.077 143.568 85.7767C143.558 83.9103 143.471 82.0451 143.31 80.1857H132.425V72.701H123.029Z",
    fill: "#CAC4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1465 88.8929H65.987V91.7424H63.1465V88.8929Z",
    fill: "#72797C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.987 101.046H106.828V103.896H103.987V101.046Z",
    fill: "#72797C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.113 78.8955H109.954V81.745H107.113V78.8955Z",
    fill: "#72797C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9268 86.9325H15.7673V89.782H12.9268V86.9325Z",
    fill: "#72797C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8115 100.262H37.6521V103.112H34.8115V100.262Z",
    fill: "#72797C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1572 109.867H56.9978V112.717H54.1572V109.867Z",
    fill: "#72797C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.068 76.5434H128.909V79.3928H126.068V76.5434Z",
    fill: "#72797C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.84 85.7564H138.68V88.6058H135.84V85.7564Z",
    fill: "#72797C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3066 104.694H78.1472V107.544H75.3066V104.694Z",
    fill: "#72797C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4658 113.842H90.3064V116.692H87.4658V113.842Z",
    fill: "#72797C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.876 60.2723C12.2864 60.8717 14.0059 61.2028 15.8507 60.7694C16.0079 61.1386 16.6052 61.8771 17.737 61.8771C16.4271 62.8792 14.719 65.2 18.3657 66.4658C22.0125 67.7317 34.0322 64.778 39.5862 63.1429C38.6955 64.356 37.8886 66.9405 41.7869 67.5734C46.6597 68.3646 79.1978 63.4594 82.4987 59.5036C83.9134 59.6091 87.1201 59.3137 88.6291 57.2883C92.454 58.5014 100.953 60.1998 104.348 57.2883C108.173 57.7103 116.514 57.5731 119.281 53.649C121.499 54.3448 125.316 49.255 129.139 43.7942C116.558 27.494 96.8603 17 74.7194 17C45.7966 17 21.0432 34.9072 10.876 60.2723Z",
    fill: "#BFBEBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.082 125.653C118.636 143.402 98.0599 155 74.7836 155C51.5074 155 30.9315 143.402 18.4854 125.653L131.082 125.653Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.103 93.9034C107.597 107.673 102.657 136.505 102.807 149.037L105.638 147.617L108.468 146.198C104.856 123.368 119.427 103.265 127.103 95.7152V93.9034Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M162.775 80.7676C143.269 67.36 131.769 82.7304 128.458 92.0916L131.167 95.2623C138.392 97.7989 152.841 107.492 159.163 112.022C151.577 94.2658 137.338 91.3366 131.167 92.0916C138.753 79.7711 155.4 79.4087 162.775 80.7676Z",
    fill: "#A8A7A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.199 70.8026C121.776 79.8617 124.094 89.6758 127.555 93.4505C121.776 105.409 131.469 108.096 137.037 107.945C127.284 104.321 127.555 97.9801 128.91 95.2623C132.161 106.496 144.714 109.304 150.584 109.304C143.72 105.68 133.877 97.2251 129.813 93.4505C142.456 88.7397 161.872 92.0916 170 94.3564C150.855 80.9488 134.629 87.26 128.91 92.0916C127.826 85.2066 135.984 75.0302 140.199 70.8026Z",
    fill: "#C7C7C7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.6597,
    height: 25.6597,
    rx: 5.4915,
    transform: "matrix(0.882063 0.469262 -0.467793 0.884832 56.125 105.132)",
    fill: "#FF5000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7632 116.949L59.2777 109.242C58.0277 108.577 56.4769 109.055 55.814 110.309L48.1318 124.839C47.4689 126.093 47.9448 127.649 49.1948 128.314L63.6803 136.02C64.9303 136.685 66.481 136.208 67.144 134.954L74.8262 120.423C75.4891 119.169 75.0132 117.614 73.7632 116.949ZM59.5178 108.788C58.0178 107.99 56.1569 108.563 55.3613 110.068L47.6791 124.599C46.8836 126.103 47.4547 127.97 48.9548 128.768L63.4402 136.474C64.9402 137.272 66.8011 136.7 67.5966 135.195L75.2788 120.664C76.0743 119.159 75.5032 117.292 74.0032 116.494L59.5178 108.788Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.906 113.041C57.2474 113.567 57.0658 113.827 56.9541 114.402C56.8203 115.091 56.9255 115.494 57.3769 116.021C57.5619 116.237 57.7197 116.435 57.7277 116.461C57.7358 116.488 57.4981 116.584 57.1996 116.676C56.7207 116.824 56.6842 116.861 56.8894 116.989C57.7162 117.507 59.537 117.24 60.3654 116.479C61.1924 115.719 61.2809 114.497 60.5689 113.666L60.2205 113.259L60.7566 113.094C61.2293 112.948 61.2652 112.912 61.06 112.783C60.3596 112.344 58.5982 112.489 57.906 113.041Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8895 125.215L52.016 122.36L52.5893 122.183L52.9375 123.321L53.0961 123.272L53.2683 123.835L53.1097 123.884L53.4628 125.038L52.8895 125.215ZM53.4919 123.766L53.3197 123.204L53.4783 123.155L53.1301 122.017L53.7034 121.84L54.5769 124.695L54.0036 124.872L53.6505 123.718L53.4919 123.766Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6288 123.818L53.9962 121.75L54.5695 121.574L55.2022 123.642C55.239 123.752 55.3238 123.806 55.4566 123.804C55.4772 123.804 55.4916 123.802 55.4997 123.8L55.6769 124.379C55.5197 124.427 55.3454 124.42 55.1541 124.357C54.8882 124.263 54.7131 124.084 54.6288 123.818ZM55.8965 124.311L55.7193 123.732C55.7681 123.717 55.8125 123.678 55.8526 123.615C55.8854 123.558 55.8935 123.497 55.8771 123.434L55.2445 121.366L55.8137 121.191L56.4464 123.259C56.5404 123.566 56.4751 123.837 56.2507 124.073C56.1392 124.194 56.0212 124.273 55.8965 124.311Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9922 123.952L56.1187 121.097L56.692 120.92L57.5655 123.775L56.9922 123.952ZM57.4282 122.541L57.2722 122.031L57.325 122.015C57.4985 121.962 57.588 121.857 57.5936 121.7C57.5936 121.662 57.5878 121.623 57.5761 121.585C57.532 121.441 57.4347 121.365 57.2842 121.358C57.2359 121.355 57.1846 121.362 57.1304 121.379L57.0775 121.395L56.9115 120.853L57.001 120.825C57.3578 120.721 57.6458 120.771 57.8652 120.974C57.9687 121.07 58.043 121.192 58.0879 121.338C58.1709 121.619 58.1444 121.863 58.0086 122.068C58.1707 122.113 58.3057 122.244 58.4135 122.461C58.4246 122.487 58.4352 122.512 58.4454 122.536L58.7853 123.4L58.2567 123.563L57.9736 122.855C57.8854 122.644 57.7818 122.529 57.663 122.509C57.6076 122.502 57.5442 122.508 57.4729 122.527L57.4282 122.541Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0455 123.32L58.172 120.465L58.7453 120.288L59.6188 123.143L59.0455 123.32ZM59.4815 121.909L59.3255 121.399L59.3784 121.383C59.5519 121.33 59.6414 121.225 59.6469 121.068C59.6469 121.03 59.6411 120.991 59.6295 120.953C59.5854 120.809 59.4881 120.733 59.3376 120.726C59.2892 120.723 59.2379 120.73 59.1837 120.747L59.1309 120.763L58.9649 120.22L59.0544 120.193C59.4111 120.089 59.6992 120.139 59.9186 120.342C60.0221 120.438 60.0963 120.559 60.1413 120.706C60.2242 120.987 60.1978 121.23 60.0619 121.436C60.2241 121.481 60.3591 121.612 60.4669 121.829C60.4779 121.855 60.4885 121.88 60.4987 121.904L60.8387 122.768L60.3101 122.93L60.027 122.223C59.9387 122.012 59.8352 121.897 59.7164 121.877C59.6609 121.87 59.5976 121.876 59.5262 121.895L59.4815 121.909Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0989 122.688L60.2254 119.832L60.7987 119.656L61.6722 122.511L61.0989 122.688Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7716 121.673L61.3511 120.298C61.3028 120.14 61.3141 119.969 61.3849 119.783C61.4787 119.537 61.6566 119.372 61.9187 119.289L62.0947 119.864C61.9817 119.902 61.9247 119.977 61.9238 120.091C61.9217 120.103 61.9219 120.113 61.9244 120.122L62.3449 121.496C62.3582 121.54 62.3942 121.575 62.4527 121.601C62.5078 121.626 62.5664 121.629 62.6288 121.61L62.8047 122.185C62.5011 122.278 62.233 122.221 62.0003 122.013C61.8844 121.906 61.8082 121.792 61.7716 121.673ZM63.0243 122.117L62.8484 121.542C62.8484 121.542 62.8758 121.52 62.9306 121.476C62.9603 121.438 62.9773 121.401 62.9817 121.367C62.9844 121.328 62.9758 121.275 62.9559 121.21L62.9409 121.161L63.5432 121.123C63.6156 121.359 63.5806 121.584 63.4382 121.798C63.3303 121.959 63.1924 122.065 63.0243 122.117ZM62.3143 119.796L62.1383 119.221C62.3362 119.16 62.5417 119.192 62.7549 119.317C62.9468 119.43 63.0706 119.578 63.1264 119.76L62.6102 120.08L62.5915 120.019C62.5707 119.951 62.5485 119.903 62.525 119.874C62.5058 119.85 62.478 119.832 62.4415 119.82C62.4078 119.806 62.3788 119.799 62.3546 119.797L62.3143 119.796Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9817 121.8L63.78 119.265L63.841 119.246L64.4343 120.313L64.5428 121.627L63.9817 121.8ZM64.7417 121.187L64.6915 120.586L64.8379 120.541L63.8116 118.728L64.3768 118.554L65.9212 121.203L65.352 121.378L65.1646 121.057L64.7417 121.187Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1693 121.127L65.5553 119.12L65.5878 119.11L66.3957 119.816L66.7426 120.95L66.1693 121.127ZM65.4106 118.647L65.2958 118.271L65.7633 118.127L67.769 119.884L67.9787 120.57L67.7062 120.653L65.4106 118.647ZM66.7839 118.715L66.5318 117.891L67.1051 117.714L67.6243 119.411L67.5917 119.421L66.7839 118.715Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3202 120.464L67.4467 117.609L68.9267 117.154L69.1014 117.725L68.1947 118.004L68.3719 118.583L68.8964 118.421L69.0724 118.997L68.5479 119.158L68.7176 119.713L69.6243 119.434L69.8002 120.009L68.3202 120.464Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1984 128.829L57.6586 128.486C57.6794 128.554 57.7167 128.608 57.7705 128.648C57.8242 128.688 57.8726 128.71 57.9155 128.715L57.9812 128.726L58.1434 129.256C57.913 129.327 57.6857 129.287 57.4615 129.136C57.3221 129.039 57.2344 128.937 57.1984 128.829ZM56.7942 127.391C56.7027 127.092 56.7614 126.828 56.9705 126.6C57.0654 126.494 57.164 126.423 57.2661 126.389L57.4309 126.927C57.3689 126.967 57.3337 127.032 57.3253 127.12C57.322 127.148 57.3245 127.176 57.3328 127.203C57.3669 127.314 57.4787 127.384 57.6682 127.412C57.7084 127.418 57.7728 127.424 57.8614 127.433C58.0073 127.445 58.1124 127.458 58.1766 127.474C58.4361 127.537 58.6232 127.625 58.738 127.739C58.8247 127.828 58.888 127.938 58.9279 128.069C59.0036 128.316 58.975 128.557 58.842 128.791C58.7287 128.993 58.5703 129.125 58.367 129.187L58.2048 128.657C58.3064 128.611 58.3639 128.532 58.3773 128.421C58.3829 128.372 58.3779 128.321 58.3621 128.27C58.3196 128.131 58.1817 128.048 57.9482 128.022C57.9053 128.017 57.8386 128.013 57.7481 128.008C57.6432 128.004 57.5689 127.999 57.5252 127.992C57.2579 127.952 57.0647 127.854 56.9456 127.697C56.8813 127.613 56.8308 127.511 56.7942 127.391ZM57.6545 126.858L57.4898 126.32C57.7175 126.25 57.9381 126.288 58.1517 126.433C58.2761 126.52 58.3538 126.609 58.3848 126.701L57.9098 127.039C57.8749 126.924 57.7956 126.864 57.672 126.857C57.6603 126.858 57.6545 126.858 57.6545 126.858Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4408 128.843L58.5673 125.988L60.0473 125.533L60.222 126.104L59.3153 126.383L59.4925 126.962L60.017 126.801L60.193 127.376L59.6684 127.537L59.8382 128.092L60.7449 127.813L60.9208 128.388L59.4408 128.843Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2055 128.3L61.0037 125.765L61.0647 125.746L61.6581 126.813L61.7666 128.127L61.2055 128.3ZM61.9655 127.687L61.9152 127.086L62.0616 127.041L61.0354 125.228L61.6006 125.054L63.145 127.703L62.5757 127.878L62.3883 127.557L61.9655 127.687Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1064 127.01L63.5666 126.667C63.5874 126.735 63.6247 126.789 63.6784 126.829C63.7322 126.869 63.7805 126.892 63.8235 126.896L63.8892 126.907L64.0514 127.437C63.821 127.508 63.5937 127.468 63.3695 127.317C63.2301 127.22 63.1424 127.118 63.1064 127.01ZM62.7022 125.572C62.6106 125.273 62.6694 125.01 62.8785 124.782C62.9734 124.675 63.0719 124.604 63.1741 124.57L63.3388 125.108C63.2769 125.148 63.2417 125.213 63.2333 125.302C63.23 125.329 63.2324 125.357 63.2408 125.384C63.2749 125.496 63.3867 125.565 63.5761 125.593C63.6164 125.599 63.6808 125.606 63.7694 125.614C63.9153 125.626 64.0204 125.639 64.0846 125.655C64.3441 125.718 64.5312 125.806 64.646 125.92C64.7326 126.009 64.7959 126.119 64.8359 126.25C64.9116 126.497 64.8829 126.738 64.75 126.972C64.6366 127.174 64.4783 127.306 64.275 127.369L64.1128 126.838C64.2143 126.792 64.2718 126.713 64.2853 126.602C64.2909 126.553 64.2858 126.502 64.27 126.451C64.2276 126.312 64.0897 126.23 63.8562 126.203C63.8133 126.199 63.7466 126.194 63.6561 126.189C63.5512 126.186 63.4769 126.18 63.4331 126.173C63.1659 126.133 62.9727 126.035 62.8536 125.878C62.7892 125.794 62.7388 125.692 62.7022 125.572ZM63.5625 125.04L63.3978 124.501C63.6255 124.431 63.8461 124.469 64.0597 124.614C64.1841 124.701 64.2618 124.79 64.2928 124.882L63.8178 125.22C63.7829 125.106 63.7036 125.045 63.58 125.039C63.5683 125.039 63.5625 125.04 63.5625 125.04Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0892 126.234L64.6786 124.892C64.6345 124.748 64.6506 124.583 64.7268 124.395C64.8296 124.15 65.0052 123.987 65.2538 123.907L65.4297 124.483C65.3194 124.519 65.2654 124.605 65.2676 124.738C65.268 124.758 65.2694 124.773 65.2719 124.781L65.6625 126.058C65.6966 126.169 65.7809 126.227 65.9153 126.23C65.936 126.229 65.9504 126.228 65.9585 126.225L66.1357 126.805C65.9812 126.852 65.8096 126.844 65.621 126.78C65.3515 126.685 65.1742 126.503 65.0892 126.234ZM66.3593 126.736L66.1821 126.157C66.2255 126.143 66.2672 126.105 66.3073 126.042C66.3447 125.98 66.3547 125.916 66.3375 125.85L65.9469 124.573C65.9319 124.524 65.893 124.48 65.8303 124.44C65.7728 124.407 65.7125 124.398 65.6493 124.415L65.4733 123.84C65.7471 123.756 66.0029 123.806 66.2406 123.992C66.3771 124.099 66.4636 124.212 66.5002 124.332L66.9108 125.673C67.0031 125.975 66.9396 126.248 66.7204 126.491C66.6044 126.616 66.484 126.697 66.3593 126.736Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4794 126.369L66.8654 124.362L66.898 124.352L67.7058 125.058L68.0527 126.192L67.4794 126.369ZM66.7207 123.889L66.6059 123.513L67.0735 123.37L69.0791 125.126L69.2888 125.812L69.0164 125.895L66.7207 123.889ZM68.094 123.957L67.842 123.133L68.4153 122.956L68.9344 124.653L68.9019 124.663L68.094 123.957Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0372 133.207C61.935 132.841 56.5976 134.275 54.3167 135.037C52.4754 135.586 48.6834 135.876 47.0176 135.953C52.0357 138.698 78.2668 138.698 76.8982 138.469C75.8033 138.286 74.4652 137.325 73.9329 136.868C77.4 136.685 84.8055 135.571 88.0749 135.037L79.8634 135.037C78.0387 135.037 68.915 133.664 65.0372 133.207Z",
    fill: "#C4C2C2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.2097,
    cy: 7.98755,
    rx: 29.2097,
    ry: 7.98755,
    transform: "matrix(0.983236 -0.182338 0.181236 0.98344 36.7178 63.6369)",
    fill: "#C9C9C9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.4802,
    cy: 5.87377,
    rx: 21.4802,
    ry: 5.87377,
    transform: "matrix(0.981994 -0.188914 0.187775 0.982212 46.3086 70.9299)",
    fill: "#D2D2D2"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.7247,
    cy: 4.52165,
    rx: 19.7247,
    ry: 4.52165,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 46.7412 77.2691)",
    fill: "#D2D2D2"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.4212,
    cy: 4.52165,
    rx: 18.4212,
    ry: 4.52165,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 48.126 82.5496)",
    fill: "#D2D2D2"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.657,
    cy: 4.52165,
    rx: 21.657,
    ry: 4.52165,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 49.9316 86.6509)",
    fill: "#D2D2D2"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.6082,
    cy: 3.46754,
    rx: 16.6082,
    ry: 3.46754,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 57.7783 92.3751)",
    fill: "#D2D2D2"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.8432,
    cy: 3.46754,
    rx: 12.8432,
    ry: 3.46754,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 65.2812 95.6909)",
    fill: "#D2D2D2"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.9365,
    cy: 2.95275,
    rx: 10.9365,
    ry: 2.95275,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 68.5264 99.8219)",
    fill: "#D2D2D2"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.58814,
    cy: 2.58871,
    rx: 9.58814,
    ry: 2.58871,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 73.0156 103.577)",
    fill: "#D2D2D2"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.28604,
    cy: 1.96716,
    rx: 7.28604,
    ry: 1.96716,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 77.1211 107.012)",
    fill: "#D2D2D2"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.28604,
    cy: 1.96716,
    rx: 7.28604,
    ry: 1.96716,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 77.0195 109.267)",
    fill: "#D2D2D2"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.42488,
    cy: 1.73466,
    rx: 6.42488,
    ry: 1.73466,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 77.0576 111.76)",
    fill: "#D2D2D2"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.21628,
    cy: 1.40835,
    rx: 5.21628,
    ry: 1.40835,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 77.0732 113.835)",
    fill: "#D2D2D2"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.38455,
    cy: 1.18379,
    rx: 4.38455,
    ry: 1.18379,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 77.959 116.055)",
    fill: "#D2D2D2"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.37117,
    cy: 1.18379,
    rx: 3.37117,
    ry: 1.18379,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 78.374 117.826)",
    fill: "#D2D2D2"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.46611,
    cy: 1.18379,
    rx: 2.46611,
    ry: 1.18379,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 80.6318 119.305)",
    fill: "#D2D2D2"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.87436,
    cy: 0.899732,
    rx: 1.87436,
    ry: 0.899732,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 82.0322 121.1)",
    fill: "#D2D2D2"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.36042,
    cy: 0.653031,
    rx: 1.36042,
    ry: 0.653031,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 82.8887 122.268)",
    fill: "#D2D2D2"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.914578,
    cy: 0.439018,
    rx: 0.914578,
    ry: 0.439018,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 83.665 123.158)",
    fill: "#D2D2D2"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.671212,
    cy: 0.322197,
    rx: 0.671212,
    ry: 0.322197,
    transform: "matrix(0.986468 -0.163957 0.162959 0.986633 84.1631 123.892)",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyEvents);
export default __webpack_public_path__ + "static/media/emptyEvents.9e9d752d07cc03fe288899e715105562.svg";
export { ForwardRef as ReactComponent };